import './IconButton.scss';
import React from 'react';
import LikeIconPath from '../../assets/icons/icon-like.svg';
import DislikeIconPath from '../../assets/icons/icon-dislike.svg';

const IconButton = ({ iconName, onClick }) => {

  let iconPath;
  switch (iconName) {
    case 'like':
      iconPath = LikeIconPath;
      break;
    case 'dislike':
      iconPath = DislikeIconPath;
      break;
    default:
      iconPath = '';
  }

  return (
    <button className="icon-button" onClick={onClick} aria-label={iconName}>
      <img src={iconPath} alt={iconName} />
    </button>
  );
};

export default IconButton;